import '../styles/componentStyles/TrackerHeading.css';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { useState, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import { formatDate } from '../../shared/util/helperfunctions';

function TrackerHeading({ title, setDate, isSaved }) {
  const [numDays, setNumDays] = useState(0);
  const [popupOpen, setPopupOpen] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const date = new Date();
    date.setDate(date.getDate() + numDays);
    setDate(formatDate(date));
  }, [numDays, setDate]);

  const forceDecrease = () => {
    if (numDays > -7 && popupOpen === 'decrease') {
      setNumDays((prevNumDays) => prevNumDays - 1);
      setPopupOpen(null);
    }
  };

  const decreaseDays = () => {
    if (!isSaved && numDays > -7) {
      setPopupOpen('decrease');
    } else if (numDays > -7) {
      setNumDays(numDays - 1);
    }
  };

  const forceIncrease = () => {
    if (numDays < 0 && popupOpen === 'increase') {
      setNumDays((prevNumDays) => prevNumDays + 1);
      setPopupOpen(null);
    }
  };

  const increaseDays = () => {
    if (!isSaved && numDays < 0) {
      setPopupOpen('increase');
    } else if (numDays < 0) {
      setNumDays(numDays + 1);
    }
  };

  const getDay = () => {
    const date = new Date();
    date.setDate(date.getDate() + numDays);

    if (numDays === 0) {
      return t('T464');
    }
    if (numDays === -1) {
      return t('T022');
    }
    if (numDays >= -7 && numDays < -1) {
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });
    }
  };

  useKeyboardAction(
    (event) => {
      if (popupOpen) {
        setPopupOpen(null);
        event.preventDefault();
      }
    },
    'Escape',
    2
  );

  return (
    <div className="tracker-heading fs-mask" role="group" aria-label={t('tracker.date.picker')}>
      {popupOpen && (
        <FocusLock returnFocus>
          <div className="popup" role="dialog" aria-modal="true">
            <span className="sr-only">{t('modal.tracker.unsaved.changes')}</span>
            <div className="popup-heading">{t('T538')}</div>
            <div className="popup-text">{t('T539')}</div>
            <div className="btn-cont">
              <Button
                onClick={() => {
                  setPopupOpen(null);
                }}
                color="dark"
                variant="secondary"
              >
                {t('T067')}
              </Button>
              <Button onClick={popupOpen === 'increase' ? forceIncrease : forceDecrease}>
                {t('T066')}
              </Button>
            </div>
          </div>
        </FocusLock>
      )}
      <Button
        ariaLabel={t('trackers.heading.previousDay')}
        onClick={decreaseDays}
        isDisabled={numDays <= -7}
        icon={{
          faIconDefinition: faChevronLeft,
        }}
        color="dark"
        variant="ghost"
      />
      <div>
        {t(title)}: {getDay()}
      </div>
      <Button
        ariaLabel={t('trackers.heading.nextDay')}
        onClick={increaseDays}
        isDisabled={numDays >= 0}
        icon={{
          faIconDefinition: faChevronRight,
        }}
        variant="ghost"
        color="dark"
      />
    </div>
  );
}

export default TrackerHeading;
